import React from "react";

export const VolvoShortIntroHeader = () => {
  return (
    <h2 className={'container-caption'}> 3. Получите консультацию по кредиту</h2>
  )
}
